<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import ThreeColumnLayout from '@/components/_common/ThreeColumnLayout.vue';
import ShipmentOperationalMap from '@/components/shipment/operational/ShipmentOperationalMap.vue';
import ShipmentDetailPanel from '@/components/shipment/detail/ShipmentDetailPanel.vue';
import ShipmentDetailsNavBar from '@/components/shipment/details/ShipmentDetailsNavBar.vue';
import ShipmentDetailsBar from '@/components/shipment/details/ShipmentDetailsBar.vue';

import { useSynchronizedSidebars } from '@/composables/useSynchronizedSidebars';
useSynchronizedSidebars({ defaultOpenSidebar: 'left' });

import { useResetChatOnSidebarClose } from '@/composables/useResetChatOnSidebarClose';
useResetChatOnSidebarClose();

import { useResetChatOnAccountOrUserChange } from '@/composables/useResetChatOnAccountOrUserChange';
useResetChatOnAccountOrUserChange();

import * as events from '@/events';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { setTitle } from '@/utils/title';
import { useRoute } from 'vue-router';
import { getAccountShipmentV2 } from '@gpx-spa/queries';
import getAccountShipmentExceptions from '@gpx-spa/queries/src/getAccountShipmentExceptions';

const store = useStore();
const route = useRoute();

const accountId = computed(() => store.getters['auth/accountId'] as number);
const shipmentId = computed(() => {
  const raw = route.params.id;
  const n = raw != null ? Number(raw) : 0;
  return Number.isFinite(n) && n > 0 ? n : 0;
});

const { data: shipmentDetail } = getAccountShipmentV2(accountId, shipmentId);
const mapShipments = computed(() =>
  shipmentDetail.value ? [shipmentDetail.value] : [],
);

const exceptionsQuery = getAccountShipmentExceptions(accountId, shipmentId);
const exceptionRows = computed(() => exceptionsQuery.data.value ?? []);

setTitle('Shipments');
onMounted(() => {
  events.trigger(events.names.GEOFENCE_LIST_VIEWED);
});
</script>

<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <ShipmentDetailsNavBar :shipment="shipmentDetail ?? null" />
    </template>
    <template #left>
      <ShipmentDetailPanel
        class="block h-full min-h-0 w-full"
        :shipment="shipmentDetail ?? undefined"
      />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
          <ShipmentDetailsBar :shipment="shipmentDetail ?? null" />
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <ShipmentOperationalMap
        :account-id="accountId"
        :shipments="mapShipments"
        :exceptions="exceptionRows"
        layers-persistence-key="shipment-detail"
      />
    </template>
  </ThreeColumnLayout>
</template>
